import React from "react";
import CustomButton from "./CustomButton";
import { useTaxiActions } from "../store/useActions";
import { useSelector } from "react-redux";
import { sendHapticFeedback } from "../services/telegram";

const TariffSelector = () => {
  const { femaleCrew } = useSelector((state) => state.taxi);
  const { setFemaleCrew } = useTaxiActions();

  const selectStandard = () => {
    sendHapticFeedback();
    setFemaleCrew(false);
  };

  const selectFemale = () => {
    sendHapticFeedback();
    setFemaleCrew(true);
  };

  return (
    <div style={{ display: "flex", gap: "8px", width: "100%" }}>
      <CustomButton
        width="50vw"
        height="3em"
        text={"Стандарт"}
        backgroundColor={!femaleCrew ? "#10b981" : "#4b5563"}
        onClick={selectStandard}
      />
      <CustomButton
        width="50vw"
        height="3em"
        text={"Женский экипаж"}
        backgroundColor={femaleCrew ? "#e91e8c" : "#4b5563"}
        onClick={selectFemale}
      />
    </div>
  );
};

export default TariffSelector;
